function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 7.2,
  height: 0.96,
  x: 2.6,
  y: 3,
  fill: "currentColor",
  rx: 0.48
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 1.4C0 .63.63 0 1.4 0h10.4c.77 0 1.4.63 1.4 1.4v3.2a.6.6 0 11-1.2 0V1.4a.2.2 0 00-.2-.2H1.4a.2.2 0 00-.2.2v13.2c0 .11.09.2.2.2h4.4a.6.6 0 110 1.2H1.4A1.4 1.4 0 010 14.6V1.4z",
  clipRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 7.2,
  height: 0.96,
  x: 2.6,
  y: 5.4,
  fill: "currentColor",
  rx: 0.48
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 5.6,
  height: 0.96,
  x: 2.6,
  y: 7.8,
  fill: "currentColor",
  rx: 0.48
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 4.8,
  height: 0.96,
  x: 2.6,
  y: 10.2,
  fill: "currentColor",
  rx: 0.48
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.87 13.82l3.53-6.08-.9-.62L9 13.15v.97l.87-.3zm-1.01 1.62l1.54-.53a.8.8 0 00.43-.36l3.8-6.53a.8.8 0 00-.24-1.06L12.83 5.9a.8.8 0 00-1.14.26l-3.78 6.5a.8.8 0 00-.11.4v1.63a.8.8 0 001.06.76z",
  clipRule: "evenodd"
});

function SvgAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none",
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.67acfcbe.svg";
export { ForwardRef as ReactComponent };